import React, { useContext} from 'react';
import '../../../ui-styles/bottomSlider/BottomSlider.css';
import CreateDays from "./createDays";
import { LangCtx } from "../../../lib/context";

const AddNewSchedule = (props) => {
    const { l } = useContext(LangCtx);

    return <div className={props.open ? "btmSlider slideUp" : "btmSlider"}>
        <div className="btmSliderPaper">
            <div className="btmSliderHdr">
                <div className="btmHeaderRow">
                    <div className="hdrTxtGroup" onClick={props.handleClose}>
                        <span className="hdrBtnTxt">{l.cancel}</span>
                    </div>
                </div>
            </div>
            <div className="btmSliderBdy">
                <CreateDays loadSch={props.loadSch}/>
            </div>
        </div>
    </div>

}

export default AddNewSchedule;